import { BaseError } from '@kiplin/web-common/error';

export class ClientGamesRefreshFailedError extends BaseError {
  public constructor() {
    super('45d3c6da-22e1-44d3-a2ef-31e2de6ae0aa', 'Client games refresh failed');
  }
}
